export const truncateString = (text, maxLength) => {
  if (text) {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }

    return text;
  }

  return "";
};
